"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SideNavDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("../../elements/Tooltip"));

var _Icons = require("../../foundation/Icons");

var _Navigation = require("../../elements/Navigation");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SideNavDefaultProps = {
  indexRoute: '/'
};
exports.SideNavDefaultProps = SideNavDefaultProps;

var SideNav = function SideNav(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sidenav"
  }, props.dashboardTooltip ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    tooltipBody: props.dashboardTooltip
  }, /*#__PURE__*/_react.default.createElement(_Navigation.NavItem, {
    exact: true,
    overrideNavLink: props.overrideDashboardLink,
    route: props.indexRoute,
    classNames: "nav-item nav-item--dashboard"
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoFourSquares, null))) : /*#__PURE__*/_react.default.createElement(_Navigation.NavItem, {
    exact: true,
    overrideNavLink: props.overrideDashboardLink,
    route: props.indexRoute,
    classNames: "nav-item nav-item--dashboard"
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoFourSquares, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-list"
  }, props.children));
};

SideNav.propTypes = {
  indexRoute: _propTypes.default.string.isRequired,
  children: _propTypes.default.node,
  dashboardTooltip: _propTypes.default.string,
  overrideDashboardLink: _propTypes.default.elementType
};
SideNav.defaultProps = SideNavDefaultProps;
var _default = SideNav;
exports.default = _default;